export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6185.bf4c06ab.jpg";